import React, { useRef } from 'react'
import emailjs from '@emailjs/browser'
import {useTranslation } from "react-i18next"

export const ContactForm = () => {
  const form = useRef()
  const {t} = useTranslation()

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_aokww4f", "template_k5cslp8", form.current, "zNttjDfiZX2Omcnj6")
      .then((result) => {
          console.log(result.text);
          console.log('message sent')
          e.target.reset();
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <form ref={form} onSubmit={sendEmail} className='w-11/12 max-w-sm rounded overflow-hidden shadow-2xl mx-auto pb-16 mt-12 w-full md:mx-12'>
      <div className='w-9/12 flex flex-col mx-12 mt-12'>
        <label >{t('name')}</label>
        <input type="text" name="user_name" placeholder='John Wick' className='border-b-4 border-grey-100' />
        <label className='mt-8'>Email</label>
        <input type="email" name="user_email" placeholder='name@BusinessEmail.com' className='border-b-4 border-grey-100'/>
        <label htmlFor="services" className='mt-8'>{t('service')}</label>
        <select name="user_service" required={true} defaultValue={'disable-value'} className='border-b-4 border-grey-100'>
          <option disabled value={'disable-value'} > -- {t('option')} -- </option>
          <option name='document-translation' value="document-translation">{t('doctranslation')}</option>
          <option name='dubbing' value="dubbing">{t('dubbing')}</option>
          <option name='voice-over' value="voice-over">{t('voiceover')}</option>
          <option name='professional-video-production' value="professional-video-production">{t('proffesionalvideo')}</option>
          <option name='remote-sim-interpretation' value="remote-sim-interpretation">{t('interpretation')}</option>
        </select>
        <label className='mt-8'>{t('message')}</label>
        <textarea name="message" placeholder={t('messageplaceholder')} className='border border-solid border-black h-32 p-4'/>
        <input type="submit" value={t('send')} className='bg-orange-700 text-white rounded hover:cursor-pointer mt-8' />
        
      </div>
    </form>
  );
};

export default ContactForm